query Lead($id: String) {
  lead(id: $id) {
    id
    origin
    crmLink
    phones {
      phone
      origin
      verifiedAt
    }
    email
    phone
    formattedPhone: phone(formatted: true)
    firstname
    lastname
    createdAt
    confirmedAt
    exportedAt
    dueDate
    position
    currentStatus
    isDataProcessingPermissionGranted
    communicationNotAccepted
    phoneCommunicationAccepted
    tags
    assignedUser {
      id
    }
    statusHistory {
      userName
      status
      createdAt
    }
    commentaries {
      id
      userName
      userId
      text
      createdAt
    }
    subscriptions {
      campaign {
        name
      }
      subscribedAt
      unsubscribedAt
    }
    channels {
      name
      channelId
      subscribedAt
      unsubscribedAt
      pausedAt
    }
    messages {
      createdAt
      step {
        name
        campaign {
          name
        }
      }
    }
    activities {
      type
      createdAt
      initiator
      user {
        firstname
        lastname
      }
      details {
        changes {
          origin
          before {
            firstname
            lastname
            phone
            email
            isDataProcessingPermissionGranted
            communicationNotAccepted
            phoneCommunicationAccepted
          }
          after {
            firstname
            lastname
            phone
            email
            isDataProcessingPermissionGranted
            communicationNotAccepted
            phoneCommunicationAccepted
          }
        }
        campaigns {
          name
        }
        email {
          type
          channelName
          messageId
        }
        CONVERSION {
          conversionId
          conversionType
        }
        PRE_CONVERSION {
          conversionId
          preConversionId
          preConversionType
        }
        KONSTANTINE {
          potential
          sentiment
          summary
          followUp {
            boolean
            when {
              date
              timezone
            }
            reasoning
          }
          interactive
        }
        valuationId
        invitationTopic
      }
    }
    valuations {
      id
      createdByAgent
      inputs {
        coordinates {
          lat
          lng
        }
      }
    }
    conversions {
      id
      type
      personalData {
        firstname
        lastname
        phone
        formattedPhone: phone(formatted: true)
      }
      plotValuation {
        address {
          lat
          lng
        }
      }
      valuation {
        id
        reason
        inputs {
          type
          subType
          buildingYear
          landArea
          livingArea
          balconyArea
          numberOfRooms
          quality
          condition
          numberOfUnits
          annualRentIncome
          address {
            street
            houseNumber
            city
            zip
          }
          coordinates {
            lat
            lng
          }
        }
        results {
          currency
          property {
            value
          }
        }
      }
      propertyRequest {
        property {
          location {
            coordinates {
              lat
              lng
            }
            radius
          }
        }
      }
      createdAt
    }
    company {
      country
    }
    aiSummary {
        generatedAt
        summary
    }
  }
}
